import { render, staticRenderFns } from "./SecuserGrid.vue?vue&type=template&id=0f9b8f62"
import script from "./SecuserGrid.vue?vue&type=script&lang=js"
export * from "./SecuserGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports